import { connect } from "react-redux";
import { InAppTemplate } from "../../../shared/templates/inapp";
import CustomerList from "../../../views/app/customers/CustomerList";
import { appActions } from "../../../redux/actions/in-app";

const CustomersManagement = (pageProps: any) => {
  return (
    <InAppTemplate
      pageHeadingTitle="Customer Management"
      childComponent={<CustomerList />}
    />
  );
};

const mapDispatchToProps = {
  getCustomers: appActions.GetCustomers,
  getCustomerDetails: appActions.GetCustomerDetails,
  updateCustomer: appActions.UpdateCustomer,
  toggleUser: appActions.ToggleUser,
};

const mapStateToProps = (state: any) => ({
  getCustomersRequest: state.allInAppReducers.getCustomersReducer,
  getCustomerDetailsRequest: state.allInAppReducers.getCustomerDetailsReducer,
  updateCustomerRequest: state.allInAppReducers.updateCustomerReducer,
  toggleUserRequest: state.allInAppReducers.toggleUserReducer,
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomersManagement);
